'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobProviderType } from '../../Entities/Glob/GlobProviderType';
import { GlobProviderTypeCollection } from '../../Collections/Glob/GlobProviderTypeCollection';

export class GlobProviderTypeRepository extends CoreRepository {
  public getGlobProviderTypes(options: object = {}) {
    if (!options) {
      options = {};
    }
    return this.webAPI.getGlobProviderTypes(options).then((response) => {
      const collection = new GlobProviderTypeCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobProviderType();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
